import { SelectorUtil } from '../../utils/selector-util';

export class HiddenBlockRenderer {
    public render(pageId?: string): HTMLElement {
        const container = document.createElement('div');
        container.id = pageId
            ? SelectorUtil.hiddenVarsBlockIdFor(pageId)
            : SelectorUtil.hiddenVarsBlockId;
        container.setAttribute(SelectorUtil.hiddenVarsBlockAttr, '');
        container.style.display = 'none';
        return container;
    }
}
